export const EconomicsMock = [
  {
    actual: '80.300',
    actual_t: '%',
    consensus: '80.100',
    consensus_t: '%',
    country: 'USA',
    date: '2022-08-16',
    description:
      'The capacity utilization rate represents the percentage of US production capacity being utilized in the given period. The figure reflects overall growth in the economy and can act as a leading indicator of consumer price inflation. A high reading is generally taken as positive for the US economy, while a low reading is taken as negative.',
    event_name: 'Capacity Utilization Rate',
    event_period: 'Jul',
    id: '62f110339bab060001e2b3be',
    importance: 2,
    notes: '',
    period_year: 2022,
    prior: '80.000',
    prior_t: '%',
    time: '09:15:00',
    updated: 1660656401,
  },
  {
    actual: '0.700',
    actual_t: '%',
    consensus: '0.200',
    consensus_t: '%',
    country: 'USA',
    date: '2022-08-16',
    description: '',
    event_name: 'Manufacturing Outputs (MoM)',
    event_period: 'Jul',
    id: '62f110339bab060001e2b3c6',
    importance: 2,
    notes: '',
    period_year: 2022,
    prior: '-0.500',
    prior_t: '%',
    time: '09:15:00',
    updated: 1660656400,
  },
  {
    actual: '0.600',
    actual_t: '%',
    consensus: '0.300',
    consensus_t: '%',
    country: 'USA',
    date: '2022-08-16',
    description:
      'The industrial production figure is a measure of the change in value of inflation-adjusted output produced by mines, utilities, and manufacturers. A high reading is generally taken as positive for the given economy, while a low reading is taken as negative.',
    event_name: 'Industrial Production (MoM)',
    event_period: 'Jul',
    id: '62f110339bab060001e2b3c4',
    importance: 3,
    notes: '',
    period_year: 2022,
    prior: '-0.200',
    prior_t: '%',
    time: '09:15:00',
    updated: 1660656400,
  },
  {
    actual: '12.700',
    actual_t: '%',
    consensus: '',
    consensus_t: '',
    country: 'USA',
    date: '2022-08-16',
    description: '',
    event_name: 'Redbook (YoY)',
    event_period: '',
    id: '62fa16ee86af26000183a451',
    importance: 4,
    notes: '',
    period_year: 2022,
    prior: '10.400',
    prior_t: '%',
    time: '08:55:00',
    updated: 1660654851,
  },
  {
    actual: '5.000',
    actual_t: '%',
    consensus: '',
    consensus_t: '',
    country: 'CAN',
    date: '2022-08-16',
    description: '',
    event_name: 'Median CPI (YoY)',
    event_period: '',
    id: '62fa16a086af26000183a3c7',
    importance: 5,
    notes: '',
    period_year: 2022,
    prior: '4.900',
    prior_t: '%',
    time: '08:30:00',
    updated: 1660653812,
  },
  {
    actual: '-17540000000.000',
    actual_t: '$',
    consensus: '23750000000.000',
    consensus_t: '$',
    country: 'CAN',
    date: '2022-08-16',
    description:
      'Foreign Securities Purchases is a measure of the value of domestic stocks, bonds, and money-market assets purchased by foreign investors.\r\n\r\nA greater than predicted result should be taken as positive/bullish for the CAD, while a lower than predicted result should be taken as negative/bearish for the CAD.',
    event_name: 'Foreign Securities Purchases',
    event_period: 'Jun',
    id: '62f10f829bab060001e2b1ae',
    importance: 3,
    notes: '',
    period_year: 2022,
    prior: '2350000000.000',
    prior_t: '$',
    time: '08:30:00',
    updated: 1660653800,
  },
  {
    actual: '-12300000000.000',
    actual_t: '$',
    consensus: '',
    consensus_t: '',
    country: 'CAN',
    date: '2022-08-16',
    description: '',
    event_name: 'Foreign Securities Purchases by Canadians',
    event_period: 'Jun',
    id: '62f110329bab060001e2b3bc',
    importance: 2,
    notes: '',
    period_year: 2022,
    prior: '570000000.000',
    prior_t: '$',
    time: '08:30:00',
    updated: 1660653797,
  },
  {
    actual: '1674000.000',
    actual_t: '',
    consensus: '1640000.000',
    consensus_t: '',
    country: 'USA',
    date: '2022-08-16',
    description:
      'The building permits figure is the number of new building permits issued by the government, and is used as an indicator of housing demand. A high reading is generally taken as positive for the US economy, while a low reading is taken as negative',
    event_name: 'Building Permits',
    event_period: 'Jul',
    id: '62f10e3e9bab060001e2b040',
    importance: 5,
    notes: '',
    period_year: 2022,
    prior: '1696000.000',
    prior_t: '',
    time: '08:30:00',
    updated: 1660653742,
  },
  {
    actual: '7.600',
    actual_t: '%',
    consensus: '7.600',
    consensus_t: '%',
    country: 'CAN',
    date: '2022-08-16',
    description:
      "The consumer price index measures the change in the weighted average the price of goods and services, including energy and food.  It is a \nmeasure of price change from the consumer's point of view, and is a \nprimary way to measure changes in purchasing trends and inflation. A \nhigh reading is generally taken as positive for the given economy, while\n a low reading is taken as negative.",
    event_name: 'CPI (YoY)',
    event_period: 'Jul',
    id: '62f10f819bab060001e2b1ac',
    importance: 2,
    notes: '',
    period_year: 2022,
    prior: '8.100',
    prior_t: '%',
    time: '08:30:00',
    updated: 1660653741,
  },
  {
    actual: '0.100',
    actual_t: '%',
    consensus: '0.100',
    consensus_t: '%',
    country: 'CAN',
    date: '2022-08-16',
    description:
      "The consumer price index measures the change in the weighted average the price of goods and services, including energy and food.  It is a \nmeasure of price change from the consumer's point of view, and is a \nprimary way to measure changes in purchasing trends and inflation. A \nhigh reading is generally taken as positive for the given economy, while\n a low reading is taken as negative.",
    event_name: 'CPI (MoM)',
    event_period: 'Jul',
    id: '62f10ed79bab060001e2b0ea',
    importance: 3,
    notes: '',
    period_year: 2022,
    prior: '0.700',
    prior_t: '%',
    time: '08:30:00',
    updated: 1660653705,
  },
  {
    actual: '6.100',
    actual_t: '%',
    consensus: '',
    consensus_t: '',
    country: 'CAN',
    date: '2022-08-16',
    description:
      "The core consumer price index measures the change in the weighted \naverage of prices of goods and services, with the exclusion of energy \nand food.  It is a measure of price change from the consumer's point of \nview, and is a primary way to measure changes in purchasing trends and \ninflation. A high reading is generally taken as positive for the given \neconomy, while a low reading is taken as negative.",
    event_name: 'Core CPI (YoY)',
    event_period: 'Jul',
    id: '62f10ed79bab060001e2b0e8',
    importance: 3,
    notes: '',
    period_year: 2022,
    prior: '6.200',
    prior_t: '%',
    time: '08:30:00',
    updated: 1660653692,
  },
  {
    actual: '0.500',
    actual_t: '%',
    consensus: '',
    consensus_t: '',
    country: 'CAN',
    date: '2022-08-16',
    description:
      "The core consumer price index measures the change in the weighted \naverage of prices of goods and services, with the exclusion of energy \nand food.  It is a measure of price change from the consumer's point of \nview, and is a primary way to measure changes in purchasing trends and \ninflation. A high reading is generally taken as positive for the given \neconomy, while a low reading is taken as negative.",
    event_name: 'Core CPI (MoM)',
    event_period: 'Jul',
    id: '62f10ed69bab060001e2b0e6',
    importance: 5,
    notes: '',
    period_year: 2022,
    prior: '0.300',
    prior_t: '%',
    time: '08:30:00',
    updated: 1660653680,
  },
  {
    actual: '-9.600',
    actual_t: '%',
    consensus: '',
    consensus_t: '',
    country: 'USA',
    date: '2022-08-16',
    description:
      'Housing starts is a measure of the change in the annualized number of new residential buildings in which construction began during the reported month. It is a leading indicator of strength in the housing sector. \r\n\r\nA higher than expected reading should be taken as positive for the given economy, while a lower than expected reading should be taken as negative.',
    event_name: 'Housing Starts (MoM)',
    event_period: 'Jul',
    id: '62b45b6c92747d0001cb9b39',
    importance: 3,
    notes: '',
    period_year: 2022,
    prior: '-2.000',
    prior_t: '%',
    time: '08:30:00',
    updated: 1660653659,
  },
  {
    actual: '275300.000',
    actual_t: '',
    consensus: '262100.000',
    consensus_t: '',
    country: 'CAN',
    date: '2022-08-16',
    description:
      'Housing starts is a measure of the change in the annualized number of new residential buildings in which construction began during the reported month. It is a leading indicator of strength in the housing sector. \r\n\r\nA higher than expected reading should be taken as positive for the CAD, while a lower than expected reading should be taken as negative.',
    event_name: 'Housing Starts',
    event_period: 'Jul',
    id: '62f10e3e9bab060001e2b03e',
    importance: 3,
    notes: '',
    period_year: 2022,
    prior: '273800.000',
    prior_t: '',
    time: '08:15:00',
    updated: 1660653245,
  },
  {
    actual: '-1.300',
    actual_t: '%',
    consensus: '',
    consensus_t: '',
    country: 'USA',
    date: '2022-08-16',
    description:
      'The building permits figure is the number of new building permits issued by the government, and is used as an indicator of housing demand. A high reading is generally taken as positive for the given economy, while a low reading is taken as negative',
    event_name: 'Building Permits (MoM)',
    event_period: '',
    id: '62b45b6c92747d0001cb9b37',
    importance: 3,
    notes: '',
    period_year: 2022,
    prior: '0.100',
    prior_t: '%',
    time: '08:30:00',
    updated: 1660653227,
  },
  {
    actual: '5.500',
    actual_t: '%',
    consensus: '',
    consensus_t: '',
    country: 'CAN',
    date: '2022-08-16',
    description: '',
    event_name: 'Common CPI (YoY)',
    event_period: '',
    id: '62fa169f86af26000183a3c5',
    importance: 2,
    notes: '',
    period_year: 2022,
    prior: '4.600',
    prior_t: '%',
    time: '08:30:00',
    updated: 1660653067,
  },
  {
    actual: '1.955',
    actual_t: '%',
    consensus: '',
    consensus_t: '',
    country: 'GBR',
    date: '2022-08-16',
    description: '7-Year Treasury Gilt Auction',
    event_name: '7-Year Treasury Gilt Auction',
    event_period: '',
    id: '62fa144586af26000183a126',
    importance: 2,
    notes: '',
    period_year: 2022,
    prior: '1.636',
    prior_t: '%',
    time: '05:00:00',
    updated: 1660645295,
  },
  {
    actual: '0.710',
    actual_t: '%',
    consensus: '',
    consensus_t: '',
    country: 'DEU',
    date: '2022-08-16',
    description: '',
    event_name: '5-Year Bobl Auction',
    event_period: '',
    id: '62fa144586af26000183a128',
    importance: 2,
    notes: '',
    period_year: 2022,
    prior: '0.960',
    prior_t: '%',
    time: '05:30:00',
    updated: 1660645281,
  },
  {
    actual: '0.138',
    actual_t: '%',
    consensus: '',
    consensus_t: '',
    country: 'ESP',
    date: '2022-08-16',
    description: '',
    event_name: '3-Month Letras Auction',
    event_period: '',
    id: '62fa144586af26000183a124',
    importance: 2,
    notes: '',
    period_year: 2022,
    prior: '-0.210',
    prior_t: '%',
    time: '04:40:00',
    updated: 1660641039,
  },
  {
    actual: '-47.600',
    actual_t: '',
    consensus: '-48.000',
    consensus_t: '',
    country: 'DEU',
    date: '2022-08-16',
    description: '',
    event_name: 'ZEW Current Conditions',
    event_period: 'Aug',
    id: '62f10112d1d4e5000165cdd6',
    importance: 3,
    notes: '',
    period_year: 2022,
    prior: '-45.800',
    prior_t: '',
    time: '05:00:00',
    updated: 1660641030,
  },
];
